export * from './app-footer.component';
